import { LoadEffects } from './load.effects';
import { CustomerEffects } from './customer.effects';
import { FedexFacilityEffects } from './fedex-facility.effects';
import { LoadOptionsEffects } from './load-options.effects';

export const spotsEffects = [
  LoadEffects,
  CustomerEffects,
  FedexFacilityEffects,
  LoadOptionsEffects
];
